// graphql-ws servers close every socket with this code when disposed during a drain.
export const SERVER_GOING_AWAY_CLOSE_CODE = 1001;

const MIN_DELAY_MS = 100;
const FIRST_RETRY_MAX_DELAY_MS = 2_000;
const DRAIN_FIRST_RETRY_MAX_DELAY_MS = 20_000;
const BACKOFF_BASE_DELAY_MS = 1_000;
const BACKOFF_MAX_DELAY_MS = 30_000;
const UNAUTHED_DELAY_MS = 5 * 60 * 1000;

/** Full-jitter reconnect delay; widens the first retry when the server signals a deliberate drain. */
export function getWebsocketReconnectDelayMs({
  authRejected,
  lastCloseCode,
  random = Math.random,
  retries,
}: {
  authRejected: boolean;
  lastCloseCode: number | undefined;
  random?: () => number;
  retries: number;
}): number {
  if (authRejected) {
    return UNAUTHED_DELAY_MS * (0.5 + random());
  }

  let maxDelay: number;
  if (retries === 0) {
    maxDelay =
      lastCloseCode === SERVER_GOING_AWAY_CLOSE_CODE
        ? DRAIN_FIRST_RETRY_MAX_DELAY_MS
        : FIRST_RETRY_MAX_DELAY_MS;
  } else {
    maxDelay = Math.min(
      BACKOFF_MAX_DELAY_MS,
      BACKOFF_BASE_DELAY_MS * 2 ** retries,
    );
  }

  return MIN_DELAY_MS + random() * (maxDelay - MIN_DELAY_MS);
}
